export const stringToNumber = (value: string) =>
  Number(value.replace(/\D+/g, ''));
